import {
  LoginParamsTypes, LoginDataTypes, LoginSSOParamsTypes, UserInfoTypes,
} from './types';

import axiosInstance from 'services/common/instance';

const loginSSOService = async (params: LoginSSOParamsTypes): Promise<LoginDataTypes> => {
  const response = await axiosInstance.post('customers/auth/login-sso', params);
  return response.data.data;
};

export const loginService = async (params: LoginParamsTypes): Promise<LoginDataTypes> => {
  const response = await axiosInstance.post('customers/auth/login', params);
  return response.data.data;
};

export const getProfileService = async (): Promise<UserInfoTypes> => {
  const response = await axiosInstance.get('customers/me');
  return response.data.data;
};

export default loginSSOService;
